<template>
    <div>
        <QrDropdown
            :selected="formattedSelectedLanguage"
            :options="languageOptions"
            @change="changeLanguage"
            :position-class="positionClass"
        />
    </div>
</template>

<script setup>
import { getLanguage, setLanguage } from "@/libs/helper.js";
import QrDropdown from "@/components/application-ui/elements/QrDropdown.vue";
import { ref, computed, onBeforeMount } from "vue";

const props = defineProps({
    iconOnly: Boolean,
    positionClass: String,
});

const selectedLanguage = ref({
    key: 'en',
    name: 'English',
    img: '/img/flag-en.svg'
});

const formattedSelectedLanguage = computed(() => {
    if (props.iconOnly) {
        return {
            key: selectedLanguage.value.key,
            img: selectedLanguage.value.img
        }
    }

    return {
        key: selectedLanguage.value.key,
        name: selectedLanguage.value.name,
        img: selectedLanguage.value.img
    }
})

const languageOptions = computed(() => {
    return [
        { key: 'en', name: 'English', img: '/img/flag-en.svg' },
        { key: 'no', name: 'Norsk', img: '/img/flag-no.svg' },
        { key: 'se', name: 'Svenska', img: '/img/flag-se.svg' },
    ];
});

const changeLanguage = (lang) => {
    setLanguage(lang.key);
    selectedLanguage.value = languageOptions.value.find(option => option.key === lang.key);
};

onBeforeMount(() => {
    const currentLanguage = getLanguage();

    if (! currentLanguage) {
        return;
    }

    selectedLanguage.value = languageOptions.value.find(option => option.key === currentLanguage);
})

</script>
